
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/double/classroom",
      function () {
        return require("private-next-pages/double/classroom.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/double/classroom"])
      });
    }
  